import Component from 'vue-class-component'
import PreviewContainerVue from './PreviewContainer'
import { IContainerData } from '../../store/editor/components/state'

@Component
export default class RowsVue extends PreviewContainerVue<IContainerData> {
}
